/** API на том же домене: Caddy проксирует /api/* в api, в dev — прокси Vite. */
export const API_BASE = '/api/v1'

/** Бот GetSlot: кнопка меню открывает Mini App на tg.getslot.ru (API ставит её при старте), поэтому ссылка не зависит от /newapp в BotFather. */
export const MINI_APP_URL = import.meta.env.VITE_MINI_APP_URL ?? 'https://t.me/get_slot_ru_bot'

/** Часы работы оператора (Евгений, по Москве). */
export const SUPPORT_HOURS = '10:00–20:00 мск'
